module.exports = __webpack_public_path__ + "static/media/logo.2d5bc20d.svg";